module.exports = __webpack_public_path__ + "static/KeepFresh-d260ba17a5a994b1a6b0ceedd8350e8e.jpg";